<template>
  <div class="operate-release-flow-add">
    <Card shadow class="content">
      <div class="main">
       <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
        <Row class="title">
          <h4 :style="{float: 'left'}">申请资产转移</h4>
        </Row>
        <!-- <GeneralAlert></GeneralAlert> -->
        <Form inline :label-width="100" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col span="24">
              <FormItem label="标题" style="width: 100%" prop="title">
                <Input :maxlength="100" v-model="baseInfo.title" placeholder="请填写申请标题"/>
              </FormItem>
            </Col>
          </Row>
          <Row>
          <!-- <Col span="24">
              <FormItem label="残值" style="width: 100%" prop="scrap_value">
                <RadioGroup v-model="baseInfo.scrap_value" type="button">
                  <Radio :label="0">小于10万元</Radio>
                  <Radio :label="1">大于10万元</Radio>
                </RadioGroup>
              </FormItem>
            </Col> -->
            <Col span="24">
              <FormItem label="资产类型" style="width: 100%" prop="type">
                 <RadioGroup v-model="baseInfo.type" @on-change="onSelectPm">
                    <radio v-for="envModeItem in all_type_list" :key="envModeItem.key" :label="envModeItem.key">{{ envModeItem.label }}</radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
           <Row>
             <Col span="24">
              <FormItem :label="'转移资产(' + baseInfo.targetsLength + ')'" :label-width="100" prop="targetsLength">
                <Tag color="primary" v-for="(tValue, tKey, tIndex) in baseInfo.assets_d" :key="'target_asset_' + tIndex" v-if="tValue">{{ tKey }}</Tag>
                <Button type="default" icon="ios-desktop-outline" @click="openSelectServerModal()" v-if="!baseInfo.targetsLength">选择要转移的资产</Button>
                <a v-on:click="openSelectServerModal()" v-else>继续选择要转移的资产 </a>
              </FormItem>
               </Col>
          </Row>
          <Row>
            <Col span="24">
             <FormItem label="调入保管人" prop="counting_people_obj">
                <!-- <Input v-model="inventoryChangeForm.counting_people" /> -->
                <Treeselect  v-model="baseInfo.counting_people_obj" valueConsistsOf='LEAF_PRIORITY' @input="eventInput" valueFormat="object"
                 :multiple="false" :options="options"  :load-options="loadOptions" :searchable="false" :disableBranchNodes="true" placeholder="选择资产保管人">
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                  <img v-if="node.raw.avatar" width="10" height="10" :src="node.raw.avatar">{{ node.label }}
                </label>
                </Treeselect>
              </FormItem>
                             </Col>
          </Row>
           <Row>
            <Col span="24">
              <FormItem
                  v-if="baseInfo.type && baseInfo.counting_people_obj"
                  v-for="(item, index) in baseInfo.steps"
                  :key="index"
                  :label="item.name"
                  :prop="'steps.' + index + '.users_sel'"
                  :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
              <i-select v-model="item.users_sel" filterable multiple disabled>
                <i-option v-for="user in item.users" :value="user.username" :key="user.id" :label="user.name"></i-option>
              </i-select>
            </FormItem>
          </Col>
          </Row>
          <div style="text-align: center;">
            <Button type="primary" style="margin-right: 10px" :loading="submitting" @click.native="submit">提交申请</Button>
            <Button @click="$router.go(-1)">取消</Button>
          </div>
        </Form>
      </div>
    </Card>
  </div>
</template>

<script>
import { createTransferFlow, getOpsTypeReleaseSteps, getAllOpsFLowTypes, getWxOrg } from '@/api/cmdb'
import { forEach } from '@/libs/tools'
import SelectServer from '../components/select-server'
import { Treeselect, LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { GetALLUsers } from '@/api/user'

export default {
  name: 'transfer_add',
  components: {
    SelectServer,
    Treeselect
  },
  data () {
    return {
      options: [],
      pm_visible: false,
      all_user_list: [],
      all_type_list: [],
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      baseInfo: {
        flow_object: '2',
        title: '',
        assets: [],
        assets_d: {},
        targetsLength: 0,
        counting_people_obj: null,
        keeper: null,
        use_person_department: '',
        counting_people_wechat_id: null,
        type: null,
        steps: [
          {
            id: null,
            name: null,
            users: [],
            users_sel: []
          }
        ]
      },
      version: {},
      baseInfoFormRules: {
        title: { required: true, message: '标题不能为空', trigger: 'blur' },
        type: { required: true, message: '请选择流程类型', type: 'number', trigger: 'change' },
        targetsLength: [
          { required: true, type: 'number', validator: this.validArrayRule, min: 1, message: '请选择要转移的资产', trigger: 'change' }
        ],
        counting_people_obj: { required: true, message: '保管人不能为空 !', trigger: 'change', type: 'object' }
      },
      moduleList: [],
      submitting: false
    }
  },
  mounted: function () {
    this.getOrg(1)
    // this.getModuleList()
    // this.fetchStepsData()
    // this.getAllUsersData()
    this.getAllOpsTypes()
  },
  // watch: {
  //   '$store.state.user.defaultTenant' () {
  //     this.fetchStepsData()
  //     // this.getModuleList()
  //   }
  // },
  methods: {
    eventInput (value, instanceId) {
      // 调入保管人更新后要变更审批流 同时需创建devops账号（调入保管人 以及 其上级负责人）
      console.log(value)
      this.baseInfo.use_person_department = value ? value.department : ''
      this.fetchStepsData()
    },
    getOrg (id) {
      let params = {
        parentid: id
      }
      getWxOrg(params).then(res => {
        if (id === 1) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1
        }
        getWxOrg(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },
    // 数组校验器
    validArrayRule (rule, value, callback) {
      if (value === 0) {
        callback(new Error())
      } else {
        callback()
      }
    },
    // 选择服务器完成回调
    selectServerComplete (server, length) {
      console.log(server)
      this.baseInfo.assets_d = server
      this.baseInfo.targetsLength = length
    },
    // 打开资产选择Modal
    openSelectServerModal () {
      if (this.baseInfo.type) {
        this.$refs.SelectServer.openSelectServerModal({}, this.baseInfo.assets_d, false, this.baseInfo.type, '1,2')
      } else {
        this.$Message['error']({
          background: true,
          content: '请先选择要转移的资产类型',
          duration: 5
        })
      }
    },
    onSelectPm (value) {
      this.baseInfo.assets_d = {}
      this.baseInfo.targetsLength = 0
      this.fetchStepsData()
    },
    initPm (value) {
      this.baseInfoFormRules.pm[0].required = value
    },
    // 获取所有类型列表
    getAllOpsTypes () {
      this.all_type_list = []
      let params = {
      }
      getAllOpsFLowTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, label: result[i].name })
        }
        this.all_type_list = this.all_type_list.filter(item => item.label !== '研发测试设备')
      })
    },
    // 获取所有用户列表
    getAllUsersData () {
      this.all_user_list = []
      let params = {
        'group_name': '产品组'
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    fetchStepsData () {
      // flow_object: ("1", "报废"),  ("2", "转移")
      if (this.baseInfo.type && this.baseInfo.counting_people_obj) {
        this.baseInfo.steps = []
        let data = {
          type_id: this.baseInfo.type,
          flow_object: '2',
          keeper_email: this.baseInfo.counting_people_obj['email'],
          keeper_name: this.baseInfo.counting_people_obj['label']
        }
        getOpsTypeReleaseSteps(data).then(res => {
          if (res.data.data instanceof Array && res.data.data.length > 0) {
            this.baseInfo.steps = res.data.data
            this.baseInfo.steps.map(item => {
              item.users_sel = item.users.map(j => j.username)
            })
            this.baseInfo.keeper = this.baseInfo.steps.filter(m => m.name === '调入保管人')[0].users[0]['id']
            console.log(this.baseInfo.steps)
          }
        })
      }
    },
    // 上传测试报告附件成功
    uploadEnclosureSuccess (res, file) {
      console.log(file)
      if (res) {
        this.baseInfo.enclosure = res
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传测试报告附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传测试报告格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传测试报告超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为10M'
      })
    },
    // 提交
    submit () {
      this.baseInfo.assets = []
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          forEach(this.baseInfo.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            this.baseInfo[stepName] = item.users_sel
          })
          for (let asset in this.baseInfo.assets_d) {
            this.baseInfo.assets.push(this.baseInfo.assets_d[asset])
          }
          this.submitting = true
          createTransferFlow(this.baseInfo).then(res => {
            this.$Notice.success({ title: '操作成功' })
            this.$router.push({ name: 'asset_transfer_detail', params: { id: res.data.id } })
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .operate-release-add-content {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
